/**
 * How many days ahead Today's Coming up looks, for its screen and its row
 * on the profile (ComingUpScreen).
 *
 * Used by: UserProfile (the row's summary) and ComingUpScreen.
 *
 * @module useComingUpDays
 */

import { useTranslation } from '@/shared/hooks/useTranslation';
import { useUserConfig } from '@/shared/context/userConfigStore';
import { useGrowSettings } from '@/shared/lib/growSettings';

/**
 * The days Coming up looks ahead, as chosen or the usual, and how to say a
 * number of them: for the screen and for its row on the profile.
 *
 * @returns The days shown and the usual number (undefined until the app has heard the Grow setting), and a number of days in words.
 */
export function useComingUpDays(): { shown: number | undefined; usual: number | undefined; words: (days: number) => string } {
  const { reactTranslate: t } = useTranslation();
  const { userConfig } = useUserConfig();
  const settings = useGrowSettings();
  const usual = settings['today.HEADS_UP_DAYS'];
  /** A days-ahead choice in words: "Today only", "1 day", "3 days". */
  const words = (days: number): string => (days === 0 ? t('profile.preferences.headsUp.none')
    : days === 1 ? t('profile.preferences.headsUp.one') : t('profile.preferences.headsUp.days', { count: days }));
  return { shown: userConfig.preferences.headsUpDays ?? usual, usual, words };
}
